import type { EventVenueMap } from "@tih/shared";

/** @deprecated Prefer event `venueMap` from the public event API. */
export const COMING_SOON_VENUE = {
  building: "2nd Floor · Thobani Center",
  area: "Nakasero, Kampala",
  mapsQuery: "Thobani Centre, Nakasero, Kampala, Uganda",
  mapTitle: "Thobani Center",
} as const;

export function venueDirectionsUrlFrom(venue: EventVenueMap): string {
  if (venue.mapsUrl?.trim()) return venue.mapsUrl.trim();
  const q =
    venue.mapsQuery?.trim() ||
    [venue.name, venue.address].filter(Boolean).join(", ");
  return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(q)}`;
}

export function venueMapEmbedUrlFrom(venue: EventVenueMap): string {
  if (venue.embedUrl?.trim()) return venue.embedUrl.trim();
  const q =
    venue.mapsQuery?.trim() ||
    [venue.name, venue.address].filter(Boolean).join(", ");
  return `https://www.google.com/maps?q=${encodeURIComponent(q)}&z=17&hl=en&output=embed`;
}

export function venueAddressLines(venue: EventVenueMap): string[] {
  if (venue.address?.trim()) {
    return venue.address
      .split(/\n|,/)
      .map((s) => s.trim())
      .filter(Boolean);
  }
  return [venue.name];
}
